var React = require('react');

function ArrowRoundedInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"26","cy":"26","r":"25","fill":"white","stroke":"#0007EC","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M11 24C9.89543 24 9 24.8954 9 26C9 27.1046 9.89543 28 11 28V24ZM41.4142 27.4142C42.1953 26.6332 42.1953 25.3668 41.4142 24.5858L28.6863 11.8579C27.9052 11.0768 26.6389 11.0768 25.8579 11.8579C25.0768 12.6389 25.0768 13.9052 25.8579 14.6863L37.1716 26L25.8579 37.3137C25.0768 38.0948 25.0768 39.3611 25.8579 40.1421C26.6389 40.9232 27.9052 40.9232 28.6863 40.1421L41.4142 27.4142ZM11 28H40V24H11V28Z","fill":"#0007EC","key":1})]);
}

ArrowRoundedInline.defaultProps = {"width":"52","height":"52","viewBox":"0 0 52 52","fill":"none"};

module.exports = ArrowRoundedInline;

ArrowRoundedInline.default = ArrowRoundedInline;
